export const DEFAULT_PET_SPECIES = "dog";
